var Curriculog = Curriculog || {};

Curriculog.Proposals = (function ($, _, Backbone, Proposals) {

	Proposals = Backbone.Collection.extend({
		model: Curriculog.Proposal,

		initialize: function(models, options) {
			this.set(models);
			this.params = options.params;
		},

		url: function (ids) {
			if (ids !== undefined) {
				this.params.queryParams.set('ids', ids);
				return '/rest/proposalsbyid.json';
			}

			return '/rest/proposallist.json';
		},

		parse: function(models) {
			this.add(models, {merge: true});
			var that = this;
			_.each(this.models, function(model) {
				model.setPermissions(that.params.domParams.get('level'));
			});
		},

		proposals: function() {
			return this.models;
		},

		getIdSlice: function() {
			var pageLimits = this.params.pagingParams.getRange();
			var models = this.slice(pageLimits.pageStart, pageLimits.pageEnd);
			return _.pluck(models, 'id');
		},

		getModelSlice: function() {
			var pageLimits = this.params.pagingParams.getRange();
			var models = this.slice(pageLimits.pageStart, pageLimits.pageEnd);
			return models;
		}

	});

	return Proposals;

})($, _, Backbone, Curriculog.Proposals || {});